import Logo from "@/components/Logo";
import { useSiteContent } from "@/contexts/SiteContent";

export default function Footer() {
  const content = useSiteContent();
  const cfg = content?.footer || {};
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1c1c1c] text-[#f5f0e8] border-t border-[#c5a059]/15 pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="mb-6">
              <Logo size="md" tone="light" />
            </div>
            <p className="text-[#b8a99a] text-sm max-w-md leading-relaxed">
              {cfg.tagline || "A private real-estate house representing a curated circle of High-Net-Worth principals across Dubai, the Arabian Gulf, and beyond. Building legacies. Creating landmarks."}
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10">
            <div>
              <div className="underline-label mb-5">Explore</div>
              <ul className="space-y-3 text-[#f5f0e8]/80 text-sm">
                <li><a href="/listings" className="link-underline hover:text-[#c5a059]">Listings</a></li>
                <li><a href="/#insights" className="link-underline hover:text-[#c5a059]">Market</a></li>
                <li><a href="/#journal" className="link-underline hover:text-[#c5a059]">Journal</a></li>
              </ul>
            </div>
            <div>
              <div className="underline-label mb-5">House</div>
              <ul className="space-y-3 text-[#f5f0e8]/80 text-sm">
                <li><a href="/about" className="link-underline hover:text-[#c5a059]">About</a></li>
                <li><a href="/vision" className="link-underline hover:text-[#c5a059]">CEO Message</a></li>
                <li className="link-underline">Off-Market</li>
                <li className="link-underline">Press</li>
              </ul>
            </div>
            <div>
              <div className="underline-label mb-5">Visit</div>
              <ul className="space-y-2 text-[#b8a99a] text-sm">
                <li>B2B Office Tower</li>
                <li>Dubai Business Bay</li>
                <li>Office 905</li>
                <li className="pt-2">+971 52 115 1243</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-[#c5a059]/15">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#6a6259]">
            {cfg.copyright_line || "© 2026 AZEFAC Properties"} · RERA No. {cfg.rera_no || "2859909"}
          </div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#6a6259]">
            {cfg.credit_line || "Crafted for High-Net-Worth Principals · Dubai"}
          </div>
        </div>
      </div>
    </footer>
  );
}
